<script>
import Chart from "chart.js";
import { Bar } from "vue-chartjs";
import ChartAnnotations from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";

// custom plugin to allow padding the legend
Chart.plugins.register({
  id: "chartLegendPadding",
  beforeInit: function(chart, options) {
    if (chart.legend) {
      chart.legend.afterFit = function() {
        if (options && options.paddingBottom) this.height = this.height + options.paddingBottom;
      };
    }
  },
});

export default {
  extends: Bar,
  plugins: [ChartAnnotations, ChartDataLabels],
  props: {
    data: Object,
    options: Object,
  },
  watch: {
    data() {
      this.renderChart(this.data, this.options);
    },
    options() {
      this.renderChart(this.data, this.options);
    },
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
};
</script>
